import type { RootState } from 'state';
import type { FlightsCalendarsFiltersOptionsState } from '../slice';

function getDuration(state: RootState): FlightsCalendarsFiltersOptionsState['duration'] {
  const { duration } = state.flightCalendars.filtersOptions;
  return duration;
}

export default getDuration;
